import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../UniformComponents/Button'
import Modal from '../UniformComponents/Modal'
import FormController from '../components/form/FormController'

import './question-category.scss'

@observer
class QuestionCategoryEdit extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
    }

    async componentDidUpdate(prevProps) {
        const { showModal } = this.props
        const { categoryId, questionCateogoryStore, handleCloseModal } = this.props

        if (showModal && !prevProps.showModal) {
            await questionCateogoryStore.initQuestionCategory(categoryId, handleCloseModal)
        }
    }

    isValid = () => {
        const { questionCateogoryStore } = this.props

        const fields = ['description', 'sort']

        return fields
            .map((field) => (this.fields[field]({
                value: questionCateogoryStore.category[field],
                name: field,
            }, true)))
            .every((valid) => valid)
    }

    save = async () => {
        const { questionCateogoryStore, categoryId, handleCloseModal } = this.props

        if (!this.isValid()) {
            return
        }

        if (categoryId !== 0) {
            await questionCateogoryStore.updateCategry(categoryId, handleCloseModal)
        } else {
            await questionCateogoryStore.createCategory(categoryId, handleCloseModal)
        }
    }

    renderButtons = () => {
        const { handleCloseModal } = this.props
        return (
            <div className="form-button-wrapper">
                <Button
                    label={i18n.t('close')}
                    icon=""
                    cssClass="regular tertiary"
                    onClick={handleCloseModal}
                />
                <Button
                    label={i18n.t('save')}
                    icon="fa-light fa-floppy-disk"
                    cssClass="regular primary"
                    onClick={this.save}
                />
            </div>
        )
    }

    renderQuestionList = () => {
        const { questionCateogoryStore: { questions }, categoryId } = this.props
        if (categoryId === 0 || questions?.length === 0) return null
        return (
            <div className="check-grp">
                <label className="check-grp-label">
                    Questions (
                    {questions.length}
                    )
                </label>
                <ul className="question-list">
                    {
                        questions.map((question) => (
                            <li
                                key={`question_${question.questionId}`}
                                className="question-card"
                            >
                                {question.value}
                            </li>
                        ))
                    }
                </ul>
            </div>
        )
    }

    render() {
        const {
            showModal, handleCloseModal, questionCateogoryStore, categoryId,
        } = this.props
        return (
            <Fragment>
                <Modal
                    show={showModal}
                    onClose={handleCloseModal}
                    loading={questionCateogoryStore.formLoading}
                >
                    <div className="form-header">
                        <h2>{categoryId !== 0 ? 'Edit question category' : 'New question category'}</h2>
                        <p className="desc">
                            {categoryId !== 0 ? 'Edit your question category details below' : 'Enter details below to create a new question category'}
                        </p>
                    </div>
                    <FormController
                        fields={this.fields}
                        formFields={questionCateogoryStore.formFields}
                        setField={questionCateogoryStore.setField}
                    />
                    {this.renderQuestionList()}
                    {this.renderButtons()}
                </Modal>
            </Fragment>
        )
    }
}

export default QuestionCategoryEdit
